/* eslint react/no-array-index-key: "off" */
import React from 'react';
import { formatCurrency } from '../../../utils/CurrencyUtils';
import { getFormattedDate } from '../../../utils/dateUtils';
import {
  HistoryRow,
  HistoryRowLong,
  PaymentInfo,
  PaymentType,
  PaymentDate,
  PaymentAmount,
  PaymentTypeRed,
  PaymentTypeRow,
  PaymentAmountRed,
  PaymentPending,
  HR,
  HR2,
} from './TransactionHistoryItems.styles';

const PaymentProcessingIcon = ({ display }: any) => {
  return <>{display && <PaymentPending>Processing</PaymentPending>}</>;
};

const TransactionHistoryItems = ({ transactions, shortList }: any) => {
  const checkLabel = (label: string) => {
    if (
      label.includes('Late Fee') ||
      label.includes('NSF Fee') ||
      label.includes('Payment Reversal')
    ) {
      return true;
    }
    return false;
  };

  return (
    <>
      {transactions.map(
        ({ label, amount, date, isPending }: any, id: number) => {
          const redStyling = checkLabel(label);
          const paymentType = redStyling ? (
            <PaymentTypeRed>{label}</PaymentTypeRed>
          ) : (
            <PaymentType>{label}</PaymentType>
          );
          const paymentAmount = redStyling ? (
            <PaymentAmountRed>({formatCurrency(amount)})</PaymentAmountRed>
          ) : (
            <PaymentAmount>{formatCurrency(amount)}</PaymentAmount>
          );
          return (
            <React.Fragment key={id}>
              {shortList ? (
                <>
                  <HistoryRow>
                    <PaymentInfo>
                      <PaymentTypeRow>
                        {paymentType}
                        <PaymentProcessingIcon display={isPending} />
                      </PaymentTypeRow>
                      <PaymentDate>{getFormattedDate(date, false)}</PaymentDate>
                    </PaymentInfo>
                    {paymentAmount}
                  </HistoryRow>
                  <HR2 />
                </>
              ) : (
                <>
                  <HistoryRowLong>
                    <PaymentInfo>
                      <PaymentTypeRow>
                        {paymentType}
                        <PaymentProcessingIcon display={isPending} />
                      </PaymentTypeRow>
                      <PaymentDate>{getFormattedDate(date, false)}</PaymentDate>
                    </PaymentInfo>
                    {paymentAmount}
                  </HistoryRowLong>
                  <HR />
                </>
              )}
            </React.Fragment>
          );
        }
      )}
    </>
  );
};

export default TransactionHistoryItems;
